// SpotBounty mock data — used across all prototype screens (no backend)

export const IMAGES = {
  warehouse: "https://images.unsplash.com/photo-1553413077-190dd305871c?w=1200&q=80&auto=format",
  manufacturing: "https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?w=1200&q=80&auto=format",
  office: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=1200&q=80&auto=format",
  apartment: "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=1200&q=80&auto=format",
  hotel: "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=1200&q=80&auto=format",
  gym: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=1200&q=80&auto=format",
  logistics: "https://images.unsplash.com/photo-1494412651409-8963ce7935a7?w=1200&q=80&auto=format",
};

export const CATEGORIES = [
  { key: "warehouse", label: "Warehouse", image: IMAGES.warehouse },
  { key: "manufacturing", label: "Manufacturing", image: IMAGES.manufacturing },
  { key: "office", label: "Office", image: IMAGES.office },
  { key: "hotel", label: "Hotel", image: IMAGES.hotel },
  { key: "apartment", label: "Apartment", image: IMAGES.apartment },
  { key: "gym", label: "Gym", image: IMAGES.gym },
  { key: "logistics", label: "Trucking/Logistics", image: IMAGES.logistics },
  { key: "other", label: "Other", image: IMAGES.office },
];

// Post-purchase gallery photos — 3 unique per category (never used on locked cards).
export const DETAIL_PHOTOS = {
  warehouse: [
    "https://images.unsplash.com/photo-1553413077-190dd305871c?w=1200&q=80&auto=format",
    "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=1200&q=80&auto=format",
    "https://images.unsplash.com/photo-1497366754035-f200968a6e72?w=1200&q=80&auto=format",
  ],
  manufacturing: [
    "https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?w=1200&q=80&auto=format",
    "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=1200&q=80&auto=format",
    "https://images.unsplash.com/photo-1587293852726-70cdb56c2866?w=1200&q=80&auto=format",
  ],
  office: [
    "https://images.unsplash.com/photo-1497366216548-37526070297c?w=1200&q=80&auto=format",
    "https://images.unsplash.com/photo-1497215842964-222b430dc094?w=1200&q=80&auto=format",
    "https://images.unsplash.com/photo-1524758631624-e2822e304c36?w=1200&q=80&auto=format",
  ],
  apartment: [
    "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=1200&q=80&auto=format",
    "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=1200&q=80&auto=format",
    "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=1200&q=80&auto=format",
  ],
  hotel: [
    "https://images.unsplash.com/photo-1566073771259-6a8506099945?w=1200&q=80&auto=format",
    "https://images.unsplash.com/photo-1445019980597-93fa8acb246c?w=1200&q=80&auto=format",
    "https://images.unsplash.com/photo-1611892440504-42a792e24d32?w=1200&q=80&auto=format",
  ],
  gym: [
    "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=1200&q=80&auto=format",
    "https://images.unsplash.com/photo-1517836357463-d25dfeac3438?w=1200&q=80&auto=format",
    "https://images.unsplash.com/photo-1571902943202-507ec2618e8f?w=1200&q=80&auto=format",
  ],
  logistics: [
    "https://images.unsplash.com/photo-1494412651409-8963ce7935a7?w=1200&q=80&auto=format",
    "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=1200&q=80&auto=format",
    "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?w=1200&q=80&auto=format",
  ],
  other: [
    "https://images.unsplash.com/photo-1497366216548-37526070297c?w=1200&q=80&auto=format",
    "https://images.unsplash.com/photo-1524758631624-e2822e304c36?w=1200&q=80&auto=format",
    "https://images.unsplash.com/photo-1553413077-190dd305871c?w=1200&q=80&auto=format",
  ],
};


export const OPPORTUNITIES = [
  {
    id: "opp-001",
    category: "warehouse",
    city: "Joliet",
    state: "IL",
    zip: "60431",
    employees: 165,
    shifts: 3,
    open247: true,
    currentVending: "No current snack vending",
    verified: true,
    verification: 92,
    price: 599,
    machines: "Snack / Drink / Combo",
    listedDaysAgo: 3,
    business: "Meridian Logistics Warehouse",
    address: "1501 Centerpoint Dr, Joliet, IL 60436",
    manager: "John Smith",
    title: "Operations Manager",
    phone: "(815) 555-0142",
    email: "j.smith@meridianlogistics.com",
    bestContact: "Weekdays 9AM–3PM CT",
    image: IMAGES.warehouse,
  },
  {
    id: "opp-002",
    category: "manufacturing",
    city: "Bolingbrook",
    state: "IL",
    zip: "60440",
    employees: 210,
    shifts: 2,
    open247: false,
    currentVending: "Legacy drink machine only",
    verified: true,
    verification: 88,
    price: 749,
    machines: "Combo / Smart Cooler",
    listedDaysAgo: 1,
    business: "Ridgeline Manufacturing Co.",
    address: "820 Industrial Blvd, Bolingbrook, IL 60440",
    manager: "Priya Anand",
    title: "Facilities Director",
    phone: "(630) 555-0117",
    email: "p.anand@ridgelinemfg.com",
    bestContact: "Weekdays 8AM–4PM CT",
    image: IMAGES.manufacturing,
  },
  {
    id: "opp-003",
    category: "office",
    city: "Naperville",
    state: "IL",
    zip: "60563",
    employees: 145,
    shifts: 1,
    open247: false,
    currentVending: "No current vending",
    verified: true,
    verification: 84,
    price: 399,
    machines: "Snack / Coffee",
    listedDaysAgo: 5,
    business: "Ashwood Corporate Center",
    address: "425 Warrenville Rd, Naperville, IL 60563",
    manager: "Marcus Lee",
    title: "Office Manager",
    phone: "(630) 555-0188",
    email: "m.lee@ashwoodcc.com",
    bestContact: "Weekdays 10AM–2PM CT",
    image: IMAGES.office,
  },
  {
    id: "opp-004",
    category: "apartment",
    city: "Dallas",
    state: "TX",
    zip: "75201",
    employees: 320,
    shifts: 0,
    open247: true,
    currentVending: "No current vending",
    verified: true,
    verification: 91,
    price: 549,
    machines: "Snack / Drink",
    listedDaysAgo: 2,
    business: "Ivory Ridge Apartments",
    address: "1200 Main St, Dallas, TX 75201",
    manager: "Angela Ruiz",
    title: "Property Manager",
    phone: "(214) 555-0139",
    email: "a.ruiz@ivoryridge.com",
    bestContact: "Weekdays 10AM–5PM CT",
    image: IMAGES.apartment,
  },
  {
    id: "opp-005",
    category: "warehouse",
    city: "Romeoville",
    state: "IL",
    zip: "60446",
    employees: 178,
    shifts: 3,
    open247: true,
    currentVending: "No current snack vending",
    verified: true,
    verification: 95,
    price: 799,
    machines: "Snack / Drink / Combo",
    listedDaysAgo: 0,
    business: "Northline Distribution Center",
    address: "3300 Airport Rd, Romeoville, IL 60446",
    manager: "David Cho",
    title: "Site Director",
    phone: "(815) 555-0166",
    email: "d.cho@northlinedist.com",
    bestContact: "Weekdays 7AM–2PM CT",
    image: IMAGES.warehouse,
  },
  {
    id: "opp-006",
    category: "gym",
    city: "Aurora",
    state: "IL",
    zip: "60504",
    employees: 90,
    shifts: 0,
    open247: true,
    currentVending: "No current vending",
    verified: true,
    verification: 79,
    price: 299,
    machines: "Smart Cooler / Drink",
    listedDaysAgo: 7,
    business: "Peak Athletic Club",
    address: "4001 Fox Valley Ctr, Aurora, IL 60504",
    manager: "Nia Reed",
    title: "General Manager",
    phone: "(630) 555-0121",
    email: "n.reed@peakathletic.com",
    bestContact: "Weekdays 11AM–4PM CT",
    image: IMAGES.gym,
  },
  {
    id: "opp-007",
    category: "logistics",
    city: "Houston",
    state: "TX",
    zip: "77032",
    employees: 260,
    shifts: 3,
    open247: true,
    currentVending: "Outdated machines",
    verified: true,
    verification: 89,
    price: 699,
    machines: "Combo / Drink",
    listedDaysAgo: 4,
    business: "Gulfstream Freight Yard",
    address: "22 Cargo Way, Houston, TX 77032",
    manager: "Terrell Adams",
    title: "Yard Supervisor",
    phone: "(713) 555-0102",
    email: "t.adams@gulfstreamfr.com",
    bestContact: "Weekdays 6AM–1PM CT",
    image: IMAGES.logistics,
  },
  {
    id: "opp-008",
    category: "office",
    city: "Chicago",
    state: "IL",
    zip: "60654",
    employees: 132,
    shifts: 1,
    open247: false,
    currentVending: "No current vending",
    verified: true,
    verification: 86,
    price: 449,
    machines: "Snack / Coffee",
    listedDaysAgo: 6,
    business: "Merchant Row Offices",
    address: "601 W Randolph St, Chicago, IL 60654",
    manager: "Elena Park",
    title: "Building Manager",
    phone: "(312) 555-0193",
    email: "e.park@merchantrow.com",
    bestContact: "Weekdays 9AM–3PM CT",
    image: IMAGES.office,
  },
  {
    id: "opp-009",
    category: "hotel",
    city: "Los Angeles",
    state: "CA",
    zip: "90015",
    employees: 175,
    shifts: 3,
    open247: true,
    currentVending: "Coffee only in lobby",
    verified: true,
    verification: 83,
    price: 499,
    machines: "Snack / Drink",
    listedDaysAgo: 8,
    business: "The Vernon Downtown Hotel",
    address: "88 Grand Ave, Los Angeles, CA 90015",
    manager: "Reid Nakamura",
    title: "F&B Manager",
    phone: "(213) 555-0177",
    email: "r.nakamura@vernonhotels.com",
    bestContact: "Weekdays 12PM–6PM PT",
    image: IMAGES.hotel,
  },
];

export const SPOT_STATUSES = [
  { key: "submitted", label: "Submitted", pill: "sb-pill-blue" },
  { key: "duplicate_check", label: "Duplicate Check", pill: "sb-pill-gray" },
  { key: "awaiting_verification", label: "Awaiting Business Verification", pill: "sb-pill-amber" },
  { key: "verified", label: "Verified", pill: "sb-pill-green" },
  { key: "marketplace_ready", label: "Marketplace Ready", pill: "sb-pill-green" },
  { key: "listed", label: "Listed", pill: "sb-pill-blue" },
  { key: "sold", label: "Sold", pill: "sb-pill-gold" },
  { key: "protection", label: "Protection Period", pill: "sb-pill-amber" },
  { key: "completed", label: "Completed", pill: "sb-pill-green" },
  { key: "rejected", label: "Rejected", pill: "sb-pill-red" },
  { key: "expired", label: "Expired", pill: "sb-pill-gray" },
];

export const MY_SPOTS = [
  { id: "s1", category: "warehouse", label: "Warehouse — Joliet, IL", date: "Feb 24, 2026", status: "submitted", potential: 300 },
  { id: "s2", category: "manufacturing", label: "Manufacturing — Bolingbrook, IL", date: "Feb 22, 2026", status: "duplicate_check", potential: 350 },
  { id: "s3", category: "office", label: "Office — Naperville, IL", date: "Feb 20, 2026", status: "awaiting_verification", potential: 250 },
  { id: "s4", category: "apartment", label: "Apartment — Dallas, TX", date: "Feb 18, 2026", status: "verified", potential: 275 },
  { id: "s5", category: "warehouse", label: "Warehouse — Romeoville, IL", date: "Feb 15, 2026", status: "marketplace_ready", potential: 400 },
  { id: "s6", category: "office", label: "Office — Chicago, IL", date: "Feb 12, 2026", status: "listed", potential: 300 },
  { id: "s7", category: "logistics", label: "Trucking — Houston, TX", date: "Feb 08, 2026", status: "sold", potential: 350, awarded: true },
  { id: "s8", category: "hotel", label: "Hotel — Los Angeles, CA", date: "Feb 04, 2026", status: "protection", potential: 275 },
  { id: "s9", category: "gym", label: "Gym — Aurora, IL", date: "Jan 30, 2026", status: "completed", potential: 200, awarded: true },
  { id: "s10", category: "apartment", label: "Apartment — Chicago, IL", date: "Jan 28, 2026", status: "rejected", potential: 0 },
  { id: "s11", category: "office", label: "Office — Schaumburg, IL", date: "Jan 20, 2026", status: "expired", potential: 0 },
];

export const CAMPAIGNS = [
  {
    id: "camp-001",
    highDemand: true,
    title: "Joliet / Bolingbrook / Romeoville",
    verticals: "Warehouses + Manufacturing",
    employees: "75+ employees",
    bounty: "20% Standard Scout Bounty",
    note: "Operators Waiting In This Territory",
    image: IMAGES.warehouse,
  },
  {
    id: "camp-002",
    highDemand: false,
    title: "Dallas — Apartment Complexes",
    verticals: "Apartments",
    employees: "150+ residents",
    bounty: "18% Scout Bounty",
    note: "3 Operators actively bidding",
    image: IMAGES.apartment,
  },
  {
    id: "camp-003",
    highDemand: false,
    title: "Chicago — Warehouses",
    verticals: "Warehouses + Logistics",
    employees: "100+ employees",
    bounty: "22% Scout Bounty",
    note: "High conversion territory",
    image: IMAGES.warehouse,
  },
  {
    id: "camp-004",
    highDemand: false,
    title: "California — Corporate Offices",
    verticals: "Offices",
    employees: "80+ employees",
    bounty: "15% Scout Bounty",
    note: "Multi-tenant campuses preferred",
    image: IMAGES.office,
  },
  {
    id: "camp-005",
    highDemand: true,
    title: "Houston — Trucking & Logistics",
    verticals: "Trucking / Logistics",
    employees: "24/7 operations",
    bounty: "25% Scout Bounty",
    note: "Highest bounties in the network",
    image: IMAGES.logistics,
  },
];

export const RECENT_ACTIVITY = [
  { id: "a1", text: "Spot approved — Warehouse, Romeoville", status: "verified", time: "2h ago" },
  { id: "a2", text: "New introduction sent to operator", status: "listed", time: "8h ago" },
  { id: "a3", text: "Bounty paid — Trucking, Houston", status: "completed", time: "Yesterday" },
];

export const EARNINGS_TRANSACTIONS = [
  { id: "t1", type: "sale", label: "Location Sale — Trucking, Houston", date: "Feb 22, 2026", amount: 300 },
  { id: "t2", type: "referral", label: "Scout Referral Bonus — Priya A.", date: "Feb 18, 2026", amount: 25 },
  { id: "t3", type: "creator", label: "Creator Referral — @jordan", date: "Feb 12, 2026", amount: 50 },
  { id: "t4", type: "sale", label: "Location Sale — Gym, Aurora", date: "Feb 05, 2026", amount: 200 },
  { id: "t5", type: "payout", label: "Payout to bank ****1042", date: "Feb 01, 2026", amount: -375 },
  { id: "t6", type: "sale", label: "Location Sale — Office, Chicago", date: "Jan 25, 2026", amount: 175 },
];

// Marketplace map pins (positioned via % on a static dark map)
export const MAP_PINS = [
  { id: "opp-001", left: "42%", top: "48%" },
  { id: "opp-002", left: "44%", top: "54%" },
  { id: "opp-003", left: "39%", top: "52%" },
  { id: "opp-004", left: "48%", top: "72%" },
  { id: "opp-005", left: "40%", top: "50%" },
  { id: "opp-006", left: "37%", top: "56%" },
  { id: "opp-007", left: "52%", top: "78%" },
  { id: "opp-008", left: "43%", top: "45%" },
  { id: "opp-009", left: "15%", top: "62%" },
];

export const ADMIN_STATS = [
  { label: "New Spots", value: "1,284", delta: "+18%" },
  { label: "Business Verified", value: "962", delta: "+12%" },
  { label: "Marketplace Listings", value: "418", delta: "+9%" },
  { label: "Sold Opportunities", value: "247", delta: "+22%" },
  { label: "Gross Sales", value: "$148,320", delta: "+27%" },
  { label: "Scout Bounties", value: "$29,540", delta: "+21%" },
  { label: "Creator Commissions", value: "$8,712", delta: "+14%" },
  { label: "Refunds", value: "$1,120", delta: "-4%" },
  { label: "Automation Rate", value: "96.8%", delta: "+1.2pp" },
];

export const ADMIN_EXCEPTIONS = [
  { id: "e1", category: "Fraud Flag", title: "Duplicate submission cluster from IP 74.125.x", severity: "high" },
  { id: "e2", category: "Buyer Protection Dispute", title: "Op-#41928 requesting refund — Warehouse, Joliet", severity: "high" },
  { id: "e3", category: "Payment Issue", title: "Payout hold — Scout ID 8712 (KYC mismatch)", severity: "medium" },
];

export const SALES_OVER_TIME = [
  { name: "Wk 1", sales: 18200 },
  { name: "Wk 2", sales: 22800 },
  { name: "Wk 3", sales: 26400 },
  { name: "Wk 4", sales: 24100 },
  { name: "Wk 5", sales: 31700 },
  { name: "Wk 6", sales: 34500 },
  { name: "Wk 7", sales: 42300 },
];

export const STATUS_DONUT = [
  { name: "Verified", value: 260, color: "#22C55E" },
  { name: "Awaiting", value: 180, color: "#F59E0B" },
  { name: "Listed", value: 140, color: "#3B82F6" },
  { name: "Sold", value: 100, color: "#FFC107" },
  { name: "Rejected", value: 45, color: "#EF4444" },
];

export const CREATOR_REFERRALS = [
  { id: "cr1", name: "Alex J.", platform: "TikTok", status: "Qualified", amount: 25 },
  { id: "cr2", name: "Sam O.", platform: "YouTube", status: "Signed Up", amount: 0 },
  { id: "cr3", name: "Riley P.", platform: "Instagram", status: "Qualified", amount: 25 },
  { id: "cr4", name: "Jordan K.", platform: "Facebook", status: "Pending", amount: 0 },
  { id: "cr5", name: "Nia R.", platform: "TikTok", status: "Qualified", amount: 25 },
];

export const CONTENT_KIT = [
  { key: "tiktok", label: "TikTok Script", desc: "60-sec hook + CTA" },
  { key: "youtube", label: "YouTube Description", desc: "SEO-optimized copy" },
  { key: "instagram", label: "Instagram Caption", desc: "Story + feed variants" },
  { key: "facebook", label: "Facebook Post", desc: "Group-ready format" },
  { key: "graphic", label: "Promotional Graphic", desc: "1080x1350 PNG" },
  { key: "qr", label: "QR Poster", desc: "Printable 8.5x11" },
  { key: "logo", label: "SpotBounty Logos", desc: "SVG + PNG pack" },
];

export const PROTOTYPE_ROUTES = [
  { path: "/", label: "Landing" },
  { path: "/scouts", label: "Scouts — Landing / Waitlist" },
  { path: "/operators", label: "Operators — Landing / Waitlist" },
  { path: "/businesses", label: "Business Request" },
  { path: "/creators", label: "Creators — Landing / Waitlist" },
  { path: "/app/scout", label: "Scout App — Home" },
  { path: "/app/scout/submit", label: "Scout App — Submit a Spot" },
  { path: "/app/scout/spots", label: "Scout App — My Spots" },
  { path: "/app/scout/earnings", label: "Scout App — Earnings" },
  { path: "/app/scout/referrals", label: "Scout App — Referrals" },
  { path: "/app/scout/campaigns", label: "Scout App — Campaigns" },
  { path: "/marketplace", label: "Operator Marketplace" },
  { path: "/marketplace/opp-001", label: "Opportunity Detail" },
  { path: "/operator", label: "Operator Dashboard" },
  { path: "/verify/spb-9482-XKR", label: "Business Verification" },
  { path: "/creator", label: "Creator Dashboard" },
  { path: "/admin", label: "Owner / Admin Dashboard" },
  { path: "/admin/launch-readiness", label: "Launch Readiness" },
];
